import { RootState } from 'editor/src/store/index';

const getHideUsedPhotos = (state: RootState) => state.gallery.hideUsedPhotos;

export default getHideUsedPhotos;
